module.exports = __webpack_public_path__ + "img/login_main.75d23eca.svg";